module.exports = __webpack_public_path__ + "static/img/3_4_2.eb539442.jpg";